/* eslint-disable */
'use client';

import styles from './PlaylistSlider.module.css';
import PlaylistCard from './PlaylistCard';
import { usePathname } from 'next/navigation';
import { useState, useEffect } from 'react';
import { useAudioPlayer } from '@/context/AudioPlayerContext';
import { useSession } from 'next-auth/react';
import { toast } from 'react-hot-toast';

interface PlaylistSliderProps {
  title?: string;
  playlists?: any[];
  songs?: any[];
  works?: any[];
  userPlaylists?: any[];
  visibleCount?: number;
  onRemoveFavorite?: (id: number, type: string) => void;
  type?: string;
  items?: Array<any>;
}

export default function PlaylistSlider({
  playlists,
  songs,
  works,
  userPlaylists,
  visibleCount = 5,
  onRemoveFavorite,
  items, // 👈 добавили
}: PlaylistSliderProps) {
  const { data: session } = useSession();
  const pathname = usePathname();
  const isHistoryPage = pathname.startsWith('/library/history');
  const { playPlaylist, playTrack } = useAudioPlayer();
  const [isTouch, setIsTouch] = useState(false);
  // Собираем все элементы (старый способ)
  const playlistItems = (playlists ?? []).map(p => ({ ...p, _type: 'playlist', type: 'playlist' }));
  const songItems = (songs ?? []).map(s => ({ ...s, _type: 'song', type: 'song' }));
  const workItems = (works ?? []).map(w => ({
    id: w.id,
    title: w.title,
    imageUrl: w.imageUrl ?? '/placeholder.jpg',
    slug: w.slug,
    playlisttrack: w.song ? w.song.map(song => ({ song })) : [],
    _type: 'work',
    type: 'work',
  }));
  const userPlaylistItems = (userPlaylists ?? []).map(up => ({ ...up, _type: 'userplaylist', type: 'userplaylist' }));

  // 👇 если передан items — используем его, иначе старую сборку
  const initialItems = items && items.length > 0
    ? items
    : [...playlistItems, ...songItems, ...workItems, ...userPlaylistItems];

  const [itemsState, setItemsState] = useState(initialItems);

  // Определяем мобильный режим
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1200);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  // Индекс для десктопа
  const [startIndex, setStartIndex] = useState(0);
  const maxIndex = Math.max(0, itemsState.length - visibleCount);
const [cardsPerView, setCardsPerView] = useState(visibleCount);

useEffect(() => {
  const updateCardsPerView = () => {
    const containerWidth = document.querySelector(`.${styles.sliderContainer}`)?.clientWidth ?? 0;
    const cardWidth = 220; // твой max-width для карточки
    const count = Math.max(1, Math.floor(containerWidth / cardWidth));
    setCardsPerView(count);
  };
  updateCardsPerView();
  window.addEventListener('resize', updateCardsPerView);
  return () => window.removeEventListener('resize', updateCardsPerView);
}, []);


  
  const scroll = (direction: 'left' | 'right') => {
  setStartIndex(prev => {
    const next = direction === 'left' ? prev - cardsPerView : prev + cardsPerView;
    return Math.min(Math.max(next, 0), maxIndex);
  });
};



  // 👇 На мобильном показываем все элементы, на десктопе — только часть
  const visibleItems = isTouch
    ? itemsState // 👈 на тач‑устройствах показываем все карточки подряд
    : itemsState.slice(startIndex, startIndex + visibleCount); // 👈 на десктопе только часть


  // Удаление из истории
  const handleRemoveFromHistory = async (id: number, type: string) => {
    let endpoint = '/api/history';
    let body: any = {};

    if (type === 'playlist') body.playlistId = id;
    if (type === 'song') body.songId = id;
    if (type === 'work') body.workId = id;
    if (type === 'userplaylist') {
      endpoint = '/api/userplaylist-history';
      body.userplaylistId = id;
    }

    const res = await fetch(endpoint, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'include',
    });

    if (res.ok) {
      toast.success('Removed from history');
      setItemsState(prev => prev.filter(item => item.id !== id));
    } else {
      toast.error('Failed to remove from history');
    }
  };

  // Обновляем items при изменении пропсов
  useEffect(() => {
    if (items && items.length > 0) {
      setItemsState(items);
    } else {
      setItemsState([...playlistItems, ...songItems, ...workItems, ...userPlaylistItems]);
    }
  }, [items, playlists, songs, works, userPlaylists]);

  useEffect(() => {
    const check = () => {
      const coarse = window.matchMedia('(pointer: coarse)').matches;
      setIsTouch(coarse);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div className={styles.sliderWrapper}>
      {/* Стрелки только на десктопе */}
      {startIndex > 0 && (
        <button className={`${styles.navButton} ${styles.left}`} onClick={() => scroll('left')}>
          <img src="/icons/arrow-left.png" alt="←" className={styles.arrowIcon} />
        </button>
      )}

      <div className={styles.sliderContainer}>
        {visibleItems.map(item => {
          let playHandler;
          if (item._type === 'playlist') playHandler = playPlaylist;
          else if (item._type === 'work')
            playHandler = () => playPlaylist(item, item.id, 'work');

          else if (item._type === 'userplaylist') {
            playHandler = () => {
              if (item.tracks?.length > 0) {
                playPlaylist(
                  {
                    ...item,
                    playlisttrack: item.tracks.map(t => ({ song: t.song })),
                    _type: 'userplaylist',
                  },
                  item.id,
                  'userplaylist'
                );
              }
            };
          } else playHandler = playTrack;

          return (
            <div key={`${item._type}-${item.id}`} className={styles.cardWrapper}>
              <PlaylistCard
                playlist={item}
                onPlay={playHandler}
                type={item.type}
                onRemoveFavorite={onRemoveFavorite}
                onHistoryRemove={
                  isHistoryPage ? () => handleRemoveFromHistory(item.id, item.type) : undefined
                }
              />
            </div>
          );
        })}
      </div>

      {startIndex < maxIndex && (
        <button className={`${styles.navButton} ${styles.right}`} onClick={() => scroll('right')}>
          <img src="/icons/arrow-right.png" alt="→" className={styles.arrowIcon} />
        </button>
      )}
    </div>
  );
}
